<template>
  <div>
    <Card :bordered="false">
      <h2 slot="title">Reset Password</h2>
      <img slot="extra" src="../../assets/images/logo.png" alt="" style="width: 100px;margin-top: -14px"/>

      <Form ref="ResetPasswordForm" :model="model" :rules="resetPasswordRules" style="width: 380px;">
        <FormItem prop="NewPassword">
          <i-input
                  v-model="model.NewPassword"
                  type="password"
                  placeholder="New Password"
          >
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </i-input>
        </FormItem>
        <FormItem prop="ConfirmNewPassword">
          <i-input
                  v-model="model.ConfirmNewPassword"
                  type="password"
                  placeholder="Confirm New Password"
          >
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </i-input>
        </FormItem>
        <FormItem>
          <Button
                  type="primary"
                  :loading="submitLoading"
                  @click="handleSubmit()"
                  long
          >
            <span v-if="!submitLoading">Submit</span>
            <span v-else>Processing...</span>
          </Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>
<script>
import {resetPassword} from '../../_services/family.service'

export default {
  name: "PasswordReset",
  data() {
    const validateMatchPassword = (rule,value,callback) => {
      if(value === ''){
        callback(new Error('Please fill in confirm new password'))
      } else if(value !== this.model.NewPassword){
        callback(new Error("Password doesn't match"))
      }
      callback()
    }
    return {
      token: "",
      model: {
        NewPassword:"",
        ConfirmNewPassword:""
      },
      resetPasswordRules: {
        NewPassword:[
          {
            required:true,
            message:'Please fill in the new password',
            trigger:'blur'
          }
        ],
        ConfirmNewPassword:[
          {
            validator:validateMatchPassword, trigger:'blur'
          }
        ]
      },
      submitLoading: false
    };
  },
  created() {
    this.token = this.$route.params.token
  },
  methods: {
    handleSubmit(){
      this.$refs.ResetPasswordForm.validate(valid => {
        if(valid){
          this.submitLoading = true
          resetPassword({
            NewPassword: this.model.NewPassword,
            ConfirmNewPassword: this.model.ConfirmNewPassword,
            MailAddress: this.token
          }).then(res => {
            this.submitLoading = false
            this.$Message.success('Success Reset Password!')
            this.$router.push({name:"PasswordResetSuccess"})
          })
          .catch(error => {
            this.submitLoading = false
            this.$Message.error("Reset password Failed!");
            this.$router.push({name:"PasswordResetFailure"})
          })
        }
      })
    }
  }
};
</script>
<style scoped>
.login-form {
  width: 300px;
}
</style>
